// extracted by mini-css-extract-plugin
module.exports = {"categories":"FaqCategories_categories__5zZVl","category":"FaqCategories_category__uNWPO","selected":"FaqCategories_selected__6DZvo"};